import React from 'react';
import { useIntl } from 'react-intl';
import { GamesCategories } from '@/models/game-category.type';
import { GameCardVM } from '@/models/vm/game-card-vm.model';
import useIsHomePage from '@/hooks/useIsHomePage';
import classNames from 'classnames';
import Spinner from '@/components/UI/Spinner';

type GameListHeaderProps = {
  header: string;
  subheader?: string;
  games: GameCardVM[];
  gamesLoading: boolean;
  count: number;
  link?: GamesCategories;
};

function GameListHeader({
  header,
  subheader,
  gamesLoading,
  count,
}: GameListHeaderProps): JSX.Element {
  const intl = useIntl();
  const isHomePage = useIsHomePage();

  return (
    <div className="mb-8 lg:mb-16">
      <div className="flex justify-between items-center max-w-[1400px] mx-auto">
        <h3
          className={classNames('m-0 text-[27px] md:text-[35px] lg:text-[42px] font-bold', {
            'text-blue-blueMedium': !isHomePage,
            'text-white': isHomePage,
          })}
        >
          {header}
        </h3>
        {gamesLoading ? (
          <Spinner dark height={14} width={14} borderwidth={3} />
        ) : (
          <p
            className={classNames('m-0 text-[16px] md:text-[17px] lg:text-[19px] font-bold', {
              'text-blue-blueMedium': !isHomePage,
              'text-white/80': isHomePage,
            })}
          >
            {count}
            &nbsp;{intl.formatMessage({ id: 'header.games' })}
          </p>
        )}
      </div>
      <p
        className={classNames('m-0 leading-snug text-[14px] md:text-[16px] lg:text-[18px]', {
          'text-black/80': !isHomePage,
          'text-white/80': isHomePage,
        })}
      >
        {subheader}
      </p>
    </div>
  );
}

export default GameListHeader;
